import { h } from 'preact'
import Header from '../header'
import MethodBox from './MethodBox'
import Key from '../assets/key'
import Flag from '../ui-components/Flag'
import ButtonControl from '../button-control'
import DefaultAuthenticationBox from './DefaultAuthenticationBox'

import { Provider, ProviderList } from './types'

interface Props {
  isDefaultAuthenticationEnabled: boolean,
  toggleDefaultAuthentication: () => void,
  providers: ProviderList
}

const SSOOverviewPresenter = ({ isDefaultAuthenticationEnabled, toggleDefaultAuthentication, providers }: Props) =>
  <div>
    <Header
      title='SSO'
      disableCancelButton
      disableSaveButton
    />
    <div class='sso-overview sso-settings'>
      <div className='sso-method-title'>Default authentication method</div>
      <DefaultAuthenticationBox
        isEnabled={isDefaultAuthenticationEnabled}
        toggle={toggleDefaultAuthentication}
      />
      <div className='sso-method-title'>SSO method</div>
      {providers.map((provider: Provider) => {
        const isInstalled = provider.isInstalled

        function getButtonProps () {
          return {
            title: isInstalled ? 'Edit' : 'Install',
            variant: isInstalled ? 'secondary' : 'primary',
            onClick: isInstalled ? () => provider.onEdit(provider) : () => provider.onInstall(provider),
            class: isInstalled ? `sso-overview__${provider.name}-edit` : `sso-overview__${provider.name}-install`
          }
        }

        return <MethodBox providerName={provider.name}>
          <Key color={provider.color} />
          <div className={`method-${provider.name}`}>{provider.label}</div>
          {isInstalled && <Flag text='Installed' success />}
          <ButtonControl {...getButtonProps()} />
        </MethodBox>
      })}
      <MethodBox providerName='oauth-2'>
        <Key color='pink' />
        <div>
          <div className='method-oauth-2'>OAuth2</div>
          <div className='method-description'>Please contact <a href='mailto:support@insided.com'>support@insided</a> if you'd like to set up OAuth2</div>
        </div>
        <div />
      </MethodBox>
    </div>
  </div>

export default SSOOverviewPresenter
